import gql from 'graphql-tag';

export const WS_AUTH_UPDATE = gql`
  subscription($userId: String!) {
    webSocketAuth(userId: $userId) {
      message
    }
  }
`;
